import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ICreateDraftFromPublishedConnectionVersionParams {
  id: string;
  version: number;
}

export interface ICreateDraftFromPublishedConnectionVersionResult extends IResult {
  draftEditorUrl: string;
}

export class CreateDraftFromPublishedConnectionVersionRequest extends Request<ICreateDraftFromPublishedConnectionVersionParams, ICreateDraftFromPublishedConnectionVersionResult> {
  constructor(params: ICreateDraftFromPublishedConnectionVersionParams) {
    super('createVirtualConnectionDraftFromVersion', params);
  }
}
